module.exports = __webpack_public_path__ + "static/img/qiyerenzheng.e284d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiyerenzheng.png
// module id = OB2f
// module chunks = 18